import { Download, Latenza, Upload } from '@vfit/shared-icons';
import { Svg } from '@vfit/shared/atoms';
import {
  TechContainer,
  TechIcons,
  ExtraItemList,
  ExtraItemListTitle,
  ItemRow,
  Body,
  BodyGroup,
  BodyContainer,
  TechnologyCardDescription,
  ActionIcon,
  ContentItemRow,
} from '../consumerTechnologyCard.style';
import { purify } from '@vfit/shared/themes';
import { Content, ContentRow, ContentTitle } from '../consumerTechnologyCard.style';
import { I_TechCardProps } from './consumerTechCard.models';
import DOMPurify from 'isomorphic-dompurify';
import { purifyTextWithLogo } from '@vfit/shared/data-access';

const ConsumerTechCard = ({
  techCard,
  download,
  upload,
  latency,
  onDetail,
  extraItems,
  downloadSpeed,
}: I_TechCardProps) => {
  const { action, description } = techCard;
  const sanitizeText = DOMPurify.sanitize(description, { ADD_ATTR: ['target'] });
  const purifiedDescription = purifyTextWithLogo(sanitizeText);

  const iconsList = [
    { icon: <Download />, title: 'Download', body: download },
    { icon: <Upload />, title: 'Upload', body: upload },
    { icon: <Latenza />, title: 'Latency', body: latency },
  ];

  const extraItemsList = () => (
    <TechIcons className="extraItemsList-TechIcons">
      <ExtraItemList className="extraItemsList-ExtraItemList">
        <ItemRow className="extraItemsList-ItemRow">
          <Download />
          <ExtraItemListTitle>Velocità di Download</ExtraItemListTitle>
          <BodyContainer>
            {downloadSpeed?.map((item, index) => (
              <BodyGroup key={index}>
                <Body>{item.value}</Body>
                <Body>{item.unit}</Body>
                <Body>{item.speed}</Body>
              </BodyGroup>
            ))}
          </BodyContainer>
        </ItemRow>
        <ItemRow>
          <Latenza />
          <ExtraItemListTitle>Latenza</ExtraItemListTitle>
          <Body>{latency}</Body>
        </ItemRow>
      </ExtraItemList>
    </TechIcons>
  );

  return (
    <TechContainer>
      {purifiedDescription && (
        <TechnologyCardDescription dangerouslySetInnerHTML={{ __html: purifiedDescription }} />
      )}
      {extraItems && extraItemsList()}

      <ContentRow>
        {iconsList.map((item, index) => (
          <ContentItemRow key={`${item.title}-${index}`}>
            <Content>
              {item.title && <ContentTitle>{item.title}</ContentTitle>}
              {item.body && <Body>{item.body}</Body>}
            </Content>
          </ContentItemRow>
        ))}

        <div
          className="tooltip"
          role="presentation"
          onClick={onDetail}
          aria-label={action?.title || ''}
          style={{ display: 'flex', alignSelf: 'center' }}
        >
          <ActionIcon>
            <Svg name="info" height={16} width={16} />
          </ActionIcon>
        </div>
      </ContentRow>
    </TechContainer>
  );
};

export default ConsumerTechCard;

